export const ugovor_o_obrazovanju_radnika= {
    templateId: 211.1,
    category: 15,
    templateTitle: 'Ugovor o financiranju obrazovanja radnika',
    templateDescription: `<p>Ugovor između poslodavca i radnika kojim ugovorne strane samostalno i slobodno uređuju međusobna prava i obveze koje se odnose na obrazovanje radnika - podmirenje troškova obrazovanja, prava i obveze radnika tijekom i nakon obrazovanja i sl..</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>

    <p>Zakon o radu određuje da je dužnost poslodavca da omogući radniku, <strong>u skladu s mogućnostima</strong> i potrebama rada, školovanje, obrazovanje, osposobljavanje i usavršavanje.</p>
    <p>S druge strane, radnik je  dužan u skladu sa svojim sposobnostima i potrebama rada, školovati se, obrazovati, osposobljavati i usavršavati za rad.</p>
    <p>Dužnost omogućavanja osposobljavanja ili usavršavanja za rad osobito dolazi do izražaja prilikom uvođenja novog načina ili organizacije rada.</p>
    <p>Također, radnik ima pravo na plaćeni dopust za vrijeme obrazovanja ili stručnog osposobljavanja i usavršavanja, pod uvjetima, u trajanju i uz naknadu određenu kolektivnim ugovorom, sporazumom sklopljenim između radničkog vijeća i poslodavca ili pravilnikom o radu.</p>
    <p>Troškovi obrazovanja i izobrazbe radnika predstavljaju dvostruki trošak poslodavca. Prvi puta po ulaznim računima i obračunima kada se trošak uredovno evidentira u knjigovodstvu i kao takav umanjuje dobit društva / dohodak fizičke osobe. A drugi puta putem evidentiranja u PD obrascu (za dobitaše) odnosno DOH obrascu (za dohodaše) kada se dodatno umanjuje porezna osnovica na temelju državne potpore za obrazovanje i izobrazbu.</p>
    <p>Zakon o državnoj potpori za obrazovanje i izobrazbu daje mogućnost ostvarenja državne potpore u vidu dodatnog umanjenja porezne osnovice u godišnjem obračunu poreza na dobit te propisuje uvjete za ostvarenje takve potpore.</p>
    <p>Sukladno odredbama Pravilnika o porezu na dohodak, a u vezi s obrazovanjem radnika, poslovnim izdacima po osnovi samostalne djelatnosti smatra se:</p>
    
    <li>obrazovanje na osnovnim, srednjim, preddiplomskim, diplomskim ili integriranim preddiplomskim i diplomskim sveučilišnim studijima, odnosno preddiplomskim ili specijalističkim diplomskim stručnim studijima, poslijediplomskim studijima te u postupku za stjecanje doktorata i to plaćeni obrazovnim institucijama u tuzemstvu i inozemstvu,    </li>
    <li>naknade za tečajeve, seminare, specijalizacije, konferencije, kongrese i to u tuzemstvu i inozemstvu plaćene pravnim i fizičkim osobama ovlaštenim odnosno registriranim za obavljanje tih djelatnosti
    izdaci za nabavu knjiga, udžbenika, priručnika, skripata i druge literature u papirnatom ili elektroničkom obliku i/ili,</li>
    <li>ako se obrazovanje i izobrazba obavlja izvan mjesta prebivališta ili uobičajenog boravišta radnika, izdacima za obrazovanje i izobrazbu smatraju se i  troškovi prijevoza prigodom upućivanja na i povratka s obrazovanja i izobrazbe i to do visine cijene karata sredstvima javnog prijevoza  i troškovi smještaja do visine stvarnih izdataka,  u slučajevima seminara i savjetovanja dnevnice do visine i pod uvjetima propisanim Pravilnikom o porezu na dohodak.</li>
    <br>
    <p><strong>Da bi navedeni izdaci bili priznati kao poslovni izdaci, prvenstveno se mora raditi o radniku poslodavca, a primici koje poslodavac daje radniku moraju biti u svezi s djelatnosti poslodavca, ali ne moraju biti u svezi s trenutnim opisom radnog mjesta radnika.</strong></p>
    <p>Nadalje, školarine obrazovnim institucijama neće se smatrati plaćom samo ako su plaćene direktno obrazovnim institucijama, a naknade za tečajeve, seminare i sl. neće se smatrati plaćom samo ako su plaćene direktno pravnim i fizičkim osobama ovlaštenim odnosno registriranim za obavljanje tih djelatnosti.    </p>
    <p>Ugovorom između poslodavca i radnika se uređuju međusobne obveze vezane uz obrazovanje radnika, a često se praksa je da se takvi i slični ugovori sklapaju na način da obvezuju radnika da određeno vrijeme nakon obrazovanja nastavi raditi kod poslodavca, a u protivnom, radnik će biti dužan vratiti iznos koji je poslodavac platio za obrazovanje, ako redovno otkaže ugovor o radu, ili ako ugovor o radu redovno ili izvanredno otkaže poslodavac (osim u slučaju redovnog poslovno uvjetovanog otkaza).</p>
    <p>Takav ugovor predstavlja obveznopravni ugovor prema kojemu obje ugovorne strana samostalno i slobodno uređuju međusobna prava i obveze.</p>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o radu, Zakon o porezu na dohodak, Pravilnik o porezu na dohodak, Zakon o obveznim odnosima, Zakon o državnoj potpori za obrazovanje i izobrazbu.</p>
  `,
  sides: [
    {
        signature: 'Poslodavac:',
        inputs: [{
            type: "input",
            required: true,
            placeholder: "Poslovni subjekt",
          },
          {
            type: "input",
            required: true,
            placeholder: "Ulica i kućni broj",
          },
          {
            type: "input",
            required: true,
            placeholder: "Mjesto",
          },
          {
            type: "input",
            required: true,
            placeholder: "OIB",
          },
          {
            type: "input",
            placeholder: "Zastupa",
            inSignature: true,
          },
          {
            type: "input",
            placeholder: "Funkcija",
            inSignature: true,
          }],
        suffix: ' (u daljnjem tekstu: Poslodavac)',
        delimiter: `i`
    },
    {
        signature: 'Radnik:',
        inputs: [{
            type: 'input',
            required: true,
            placeholder: 'Ime i prezime',
            inSignature: true,
        },
            {
                type: 'input',
                required: true,
                placeholder: 'Ulica i kućni broj',
            },
            {
                type: 'input',
                required: true,
                placeholder: 'Mjesto',
            },
            
            {
                type: 'input',
                required: true,
                placeholder: 'OIB',
            },
        ],
        suffix: ' (u daljnjem tekstu: Radnik),'
    }
],

headline: 'zaključuju sljedeći',
title: 'UGOVOR O  FINANCIRANJU OBRAZOVANJA RADNIKA',
noArticleNumbers: false,

articles: [

   {
            title: 'UVODNE ODREDBE',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Ugovorne strane suglasno utvrđuju da se Radnik u trenutku sklapanja ovog Ugovora nalazi u radnom odnosu kod Poslodavca. ',
                    value: '',
                }],
        },
        {
            title: 'PREDMET UGOVORA',
            mandatory: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: false,
                    parts: [
                        { type: 'text', content: 'Ovim Ugovorom, ugovorne strane uređuju međusobne odnose povodom financiranja'},
                        {type: 'textarea', content: '​', required: true, help: 'Upišite naziv obrazovanja.'},
                        { type: 'text', content: '(u daljnjem tekstu: Obrazovanje).'},
                        ],
                }],
        },
        {
            title: 'PODMIRENJE TROŠKOVA OBRAZOVANJA',
            mandatory: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: false,
                    parts: [
                        {
                            type: 'text',
                            content: 'Ovim Ugovorom, Poslodavac se obvezuje snositi odnosno pravovremeno uplatiti ukupni trošak Obrazovanja Radnika iz ovog Ugovora koji iznosi'
                        },
                        {type: 'input', value: '', required: true, help: '(u daljnjem tekstu: Obrazovanje).'},
                        ],
                }],
        },
        {
            title: 'PODMIRENJE DODATNIH TROŠKOVA',
            exampleContent: true, 
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Poslodavac će Radniku podmiriti i sljedeće troškove vezane uz Obrazovanje iz ovog Ugovora, i to:\r\n\- nabavu knjiga, udžbenika, priručnika, skripata, \r\n\- troškove prijevoza od mjesta boravišta/prebivališta Radnika do mjesta obavljanja Obrazovanja, do visine cijene karata sredstvima javnog prijevoza, \r\n- troškove smještaja, do visine stvarnih izdataka.',
                    value: '',
                }],
        },
        {
            title: 'POČETAK OBRAZOVANJA',
            mandatory: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: false,
                    parts: [
                        {
                            type: 'text',
                            content: 'Početak Obrazovanja je'
                        },
                        {type: 'input', value: '', required: true,},
                    
                        ],
                }],
        },
        {
            title: 'OSNOVNE OBVEZE RADNIKA',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Radnik se obvezuje:\r\n- pravovremeno započeti Obrazovanje, \r\n- savjesno i odgovorno pristupiti Obrazovanju, \r\n- samostalno obavljati pripremu tijekom Obrazovanja,  \r\n- nakon završetka Obrazovanja, stečena znanja koristiti za potrebe Poslodavca, u skladu s odredbama ovog Ugovora.',
                    value: '',
                }],
        },
        {
            title: 'OBVEZA ZAVRŠETKA OBRAZOVANJA U ODREĐENOM ROKU',
            mandatory: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: false,
                    parts: [
                        {
                            type: 'text',
                            content: 'Radnik se obvezuje s uspjehom okončati Obrazovanje najkasnije'
                        },
                        {type: 'input', value: '', required: true, help: "Upišite rok završetka obrazovanja."},
                        ],
                }],
        },
        {
            title: 'OBVEZE RADNIKA NAKON OBRAZOVANJA',
            mandatory: false,
            exampleContent: true,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Nakon završetka Obrazovanja, Radnik se obvezuje raditi u okviru stečenog zvanja kod Poslodavca u periodu od ____________ ​nakon završetka Obrazovanja.',
                    value: '',
                }],
        },
        {
            title: 'PLAĆENI DOPUST',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Za vrijeme Obrazovanja, Radnik ima pravo na korištenje plaćenog dopusta u dane predavanja, vježbi, priprema i sl.. \r\nRadnik ostvaruje plaćeni dopust nakon što Poslodavac temeljem Radnikovog pisanog zahtjeva, Radniku pisanom Odlukom odobri korištenje plaćenog dopusta. \r\nU slučaju odobrenja plaćenog dopusta Radniku, Radnik ima pravo na naknadu plaće kao da je radio.',
                    value: '',
                }],
        },
        {
            title: 'OPRAVDANI RAZLOZI ZA PREKID OBRAZOVANJA',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Opravdani razlozi za prekid Obrazovanja su: teška bolest Radnika, nesretni slučaj Radnika ili slične okolnosti.\r\nOsim u slučaju teške bolesti, koju je Radnik dužan dokumentirati Poslodavcu, postojanje opravdanog razloga u svakom pojedinom slučaju utvrditi će Poslodavac diskrecijskom ocjenom, uzimajući u obzir sve relevantne okolnosti pojedinog slučaja.',
                    value: '',
                }],
        },
    {
        title: 'OTKAZ UGOVORA',
        mandatory: false,
        statements: [
            {
                type: 'text',
                required: true,
                mandatory: true,
                editable: true,
                content: 'U slučaju da: \r\n- Radnik bez opravdanog razloga prekine Obrazovanje, \r\n- Radnik ne izvrši pravovremen upis u iduću godinu/semestar Obrazovanja, \r\n- Radnik nastavi Obrazovanje u drugoj ustanovi i/ili promijeni smjer obrazovanja bez prethodnog pisanog odobrenja Poslodavca, \r\n- nastanu uvjeti za prestanak radnog odnosa skrivljeni od strane Radnika (otkaz uslijed skrivljenog ponašanja Radnika) ili ukoliko Radnik pokrene postupak otkaza Ugovora o radu te dođe do prekida (prestanka) radnog odnosa prije proteka tri godine od završetka Obrazovanja, \r\nPoslodavac ima pravo otkazati ovaj Ugovor bez otkaznog roka te je u tom slučaju Radnik dužan vratiti Poslodavcu cjelokupni iznos uplaćen na ime Obrazovanja. \r\nRadnik nema obvezu vraćanja troškova Obrazovanja, ako postane radno nesposoban, a što dokazuje nalazom i mišljenjem ovlaštenog državnog tijela za obavljanje takvih vještačenja.  ',
                value: '',
            }],
    },
    {
        title: 'NAČIN I ROKOVI POVRATA TROŠKOVA OBRAZOVANJA',
        mandatory: false,
        statements: [
            {
                type: 'text',
                required: true,
                mandatory: true,
                editable: true,
                content: 'Radnik se obvezuje, nastupanjem uvjeta za povrat troškova Obrazovanja, vratiti Poslodavcu trošak edukacije uvećan za eventualne dodatne troškove,  uvećane za zakonske zatezne kamate.',
                value: '',
            }],
    },
    {
        title: 'MJERODAVNO PRAVO',
        mandatory: false,
        statements: [
            {
                type: 'text',
                required: true,
                mandatory: true,
                editable: false,
                content: 'Na prava i obveze ugovornih stranaka, koja nisu posebno uređena ovim ugovorom, primjenjuju se odredbe Zakona o obveznim odnosima.',
                value: '',
            }],
    },
    {
        title: 'NADLEŽNOST',
        mandatory: false,
        statements: [
            {
                type: 'choice',
                mandatory: true,
                editable: false,
                choices: [
                    {
                        parts: [
                            {
                                type: 'text',
                                content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom za Poslodavca.'
                            }
                        ]
                    },
                    {
                        parts: [
                            {
                                type: 'text',
                                content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom za Radnika.'
                            }
                        ]
                    },
                    {
                        parts: [
                            {
                                type: 'text',
                                content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom u'
                            },
                            {type: 'input', value: '',help: "Upišite mjesno nadležni sud. Npr. ...sudom u Zagrebu; ...sudom u Splitu i sl..", required: true},
                            ]
                    }
                ],
                value: '',
            }
        ]
    },
    {
        title: 'PRIMJENA UGOVORA',
        mandatory: false,
        statements: [
            {
                type: 'text',
                required: false,
                mandatory: true,
                editable: true,
                content: 'Ugovor se primjenjuje od trenutka potpisa ugovornih strana.',
                value: '',
            }],
    },
    {
        title: 'PRIMJERCI UGOVORA',
        mandatory: false,
        statements: [
            {
                type: 'text',
                required: false,
                mandatory: true,
                editable: true,
                content: 'Ovaj Ugovor sastavljen je u 2 (dva) primjerka, od kojih svaka ugovorna strana zadržava po 1 (jedan) primjerak.',
                value: '',
            }],
      },
    {
        mandatory: true,
        static: true,
        type: 2, // date and place
        statements: [
          {
            type: "input",
            mandatory: true,
            parts: [
              {
                type: "text",
                content: "U"
              },
              {
                type: "input",
                value: "",
                placeholder: "Upišite mjesto.",
                required: true,
              },
              {
                type: "text",
                content: ", dana"
              },
              {
                type: "date",
                value: new Date(),
                required: true
              },
              {
                type: "text",
                content: "godine."
              }
            ]
          },
        ]
      },
      {
        mandatory: true,
        static: true,
        type: 3,  // signatures
        statements: [],
      }
    ],
  };




// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/211.1_ugovor_o_obrazovanju.ts